import recordingsNpvr from './recordings_npvr_reducer';
import recordingsDvr from './recordings_dvr_reducer';

export default { recordingsNpvr, recordingsDvr };
